<app-bar-chart
  *ngIf="valgtAnlegg && selectedDate"
  chartId="myYearchart-price"
  [dataSets]="dataSets"
  [labels]="labels"
  [title]="title"
  [tooltipCallbacks]="tooltipCallbacks"
  [xUnit]="'year'"
  [yUnit]="'kr'"
  [showLegend]="displayLegend"
  [showYTitle]="true"
></app-bar-chart>
